import { render, staticRenderFns } from "./ContactCreate.vue?vue&type=template&id=51f26ec5&scoped=true&"
import script from "./ContactCreate.vue?vue&type=script&lang=js&"
export * from "./ContactCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f26ec5",
  null
  
)

export default component.exports